import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable, take } from 'rxjs';
import { LinkModel } from '../../../models/link.model';
import { AlertService } from '../../../services/alert.service';
import { LinkService } from '../../../services/link.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-link-card',
  templateUrl: './link-card.component.html',
  styleUrl: './link-card.component.scss',
  standalone: false,
})
export class LinkCardComponent implements OnInit {
  @Input() link: LinkModel;
  @Input() allowDelete: boolean = true;
  @Output() linkDeleted: EventEmitter<LinkModel> =
    new EventEmitter<LinkModel>();

  public linkMenuItems: MenuItem[] = [
    {
      label: 'Öffnen',
      icon: 'fa-regular fa-arrow-up-right-from-square',
      command: () => {
        this.openLinkInNewTab();
      },
    },
  ];

  loadingLinkId$: Observable<number | null>;

  constructor(
    private linkService: LinkService,
    private dialogService: DialogService,
    private alertService: AlertService
  ) {
    this.loadingLinkId$ = this.linkService.loadingLink$;
  }

  ngOnInit(): void {
    if (this.allowDelete) {
      this.linkMenuItems.push({
        label: 'Löschen',
        icon: 'fa-regular fa-trash-can',
        command: () => {
          this.deleteLink(this.link);
        },
      });
    }
  }

  private deleteLink(link: LinkModel): void {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      width: '475px',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '640px': '90vw',
      },
      data: {
        title: 'Link löschen',
        message:
          'Bist du sicher, dass du diesen Link löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
        icon: 'fa-regular fa-trash-can',
        iconColor: 'red',
        confirmButtonText: 'Löschen',
      },
    });

    dialogRef.onClose.pipe(take(1)).subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.linkService
          .deleteLink(link.id)
          .pipe(take(1))
          .subscribe((success: boolean) => {
            if (success) {
              this.alertService.showSuccessAlert('Link erfolgreich gelöscht');
              this.linkDeleted.emit(link);
            }
          });
      }
    });
  }

  openLinkInNewTab() {
    window.open(this.link.url, '_blank');
  }
}
